import { XLoader } from '@adornis/chemistry/elements/components/x-loader.js';
import '@adornis/file-utils/client/x-image.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import logo from '../assets/logo.svg';

/**
 * @customElement cr-campus-loader
 */
@customElement('cr-campus-loader')
export class ChromiumCampusLoader extends XLoader {
  // @property({ type: String }) public size = '100px';

  override styles() {
    return [
      {
        img: {
          '@keyframes rotate': { '100%': { transform: 'rotate(360deg)' } },
          width: '200px',
          objectFit: 'contain',
          aspectRatio: '1 / 1',

          animation: 'rotate 2s linear infinite',
          background: 'transparent',
        },
      },
    ];
  }

  override render() {
    return html`<img src=${logo} />`;
  }
}
